import type { SortKey } from "@/lib/workUtils";

interface SortBarProps {
  sort: SortKey;
  total: number;
  onChange: (sort: SortKey) => void;
}

const sortOptions: { key: SortKey; label: string; icon: string }[] = [
  { key: "hot", label: "热门", icon: "ri-fire-line" },
  { key: "latest", label: "最新", icon: "ri-time-line" },
  { key: "rating", label: "评分", icon: "ri-star-line" },
];

export default function SortBar({ sort, total, onChange }: SortBarProps) {
  return (
    <div className="mb-5 flex flex-wrap items-center justify-between gap-3 rounded-lg border border-background-200 bg-background-50 p-3 md:p-4">
      <p className="text-sm text-foreground-600">
        共找到 <span className="font-bold text-accent-700">{total}</span> 部相关作品
      </p>
      <div className="flex items-center gap-1 rounded-full bg-background-100 p-1">
        {sortOptions.map((option) => (
          <button
            key={option.key}
            type="button"
            onClick={() => onChange(option.key)}
            className={`flex items-center gap-1 whitespace-nowrap rounded-full px-3 py-1.5 text-xs font-medium transition-colors md:px-4 ${
              sort === option.key
                ? "bg-primary-700 text-background-50"
                : "text-foreground-600 hover:text-primary-700"
            }`}
          >
            <i className={`${option.icon} text-sm`} />
            {option.label}
          </button>
        ))}
      </div>
    </div>
  );
}